import { render, staticRenderFns } from "./BandwidthDialog.vue?vue&type=template&id=40e45f18&scoped=true&"
import script from "./BandwidthDialog.vue?vue&type=script&lang=js&"
export * from "./BandwidthDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e45f18",
  null
  
)

export default component.exports